<template>
  <div class="main-container">
    <div class="gradient-background">
      <!-- 添加动态背景元素 -->
      <div class="tech-grid"></div>
      <div class="tech-circles"></div>
      <div class="tech-lines"></div>
    </div>
    <div class="content-container">
      <!-- 添加高科技装饰元素 -->
      <div class="tech-corner top-left"></div>
      <div class="tech-corner top-right"></div>
      <div class="tech-corner bottom-left"></div>
      <div class="tech-corner bottom-right"></div>
      <div class="tech-border"></div>
      
      <!-- 上方显示CallPanel，占据更大空间 -->
      <div class="call-section">
        <CallPanel 
          :user="currentRobot"
          :status="callStatus" 
          :selectedRobot="!!selectedRobotId"
          @start-call="handleStartCall"
          @hangup="handleHangup"
        />
      </div>
      <!-- 下方显示参与者列表 -->
      <div class="participants-section">
        <UserCard 
          @select-robot="handleSelectRobot"
          :selectedRobotId="selectedRobotId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UserCard from './UserCard.vue'
import CallPanel from './CallPanel.vue'
import { getTenantId } from "@/libs/util";

export default {
  components: { UserCard, CallPanel },
  data() {
    return {
      selectedRobotId: null,
      callStatus: 'idle', // 'idle', 'connected'
      currentRobot: {
        id: 0,
        avatar: require('@/assets/images/voice/Robot-icon.png'),
        name: '',
        serial: ''
      }
    }
  },
  created() {
    this.currentRobot.name = this.$translate('selectRobotPrompt');
    this.currentRobot.serial = this.$translate('systemDefaultTitle');
  },
  methods: {
    // 处理选中机器人事件
    handleSelectRobot(robot) {
      this.selectedRobotId = robot.id;
      this.currentRobot = robot;
      // 重置通话状态
      this.callStatus = 'idle';
    },
    
    // 处理开始通话
    handleStartCall() {
      if (!this.selectedRobotId) return;
      
      this.callStatus = 'connected';
      this.$Notice && this.$Notice.success({
        title: this.$translate('getTip'),
        desc: `${this.$translate('establishedConnection')} ${this.currentRobot.name} ${this.$translate('connectionEstablished')}`
      });
      
      // 这里可以添加实际的通话建立逻辑
    },
    
    // 处理挂断逻辑
    handleHangup() {
      if (this.callStatus === 'connected') {
        this.callStatus = 'idle';
        this.$Notice && this.$Notice.info({
          title: this.$translate('getTip'),
          desc: this.$translate('callHasEnded')
        });
        
        // 这里可以添加实际的通话结束逻辑
      }
    }
  }
}
</script>
<style lang="less" scoped>
.main-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #050c1a;
}

.gradient-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at center,
    #0f2547 0%,
    #091429 50%,
    #050c1a 100%
  );
  overflow: hidden;
}

/* 科技网格背景 */
.tech-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(to right, rgba(30, 144, 255, 0.05) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(30, 144, 255, 0.05) 1px, transparent 1px);
  background-size: 30px 30px;
  opacity: 0.5;
}

/* 动态圆圈 */
.tech-circles {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 800px;
  height: 800px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  box-shadow: 
    0 0 150px rgba(0, 191, 255, 0.1),
    0 0 100px rgba(0, 191, 255, 0.1),
    0 0 50px rgba(0, 191, 255, 0.1);
  opacity: 0.6;
  animation: pulse 10s infinite alternate;
}

.tech-circles::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 600px;
  height: 600px;
  transform: translate(-50%, -50%);
  border: 1px solid rgba(0, 191, 255, 0.2);
  border-radius: 50%;
  box-shadow: 0 0 50px rgba(0, 191, 255, 0.1);
  animation: rotate 20s linear infinite;
}

.tech-circles::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  height: 400px;
  transform: translate(-50%, -50%);
  border: 1px solid rgba(0, 191, 255, 0.2);
  border-radius: 50%;
  box-shadow: 0 0 50px rgba(0, 191, 255, 0.1);
  animation: rotate 15s linear infinite reverse;
}

/* 流动线条 */
.tech-lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  opacity: 0.5;
}

.tech-lines::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 140%;
  height: 100%;
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 20px,
    rgba(0, 191, 255, 0.05) 20px,
    rgba(0, 191, 255, 0.05) 40px
  );
  animation: move-lines 15s linear infinite;
}

.tech-lines::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 140%;
  height: 100%;
  background: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 20px,
    rgba(0, 191, 255, 0.05) 20px,
    rgba(0, 191, 255, 0.05) 40px
  );
  animation: move-lines 20s linear infinite reverse;
}

.content-container {
  position: relative;
  z-index: 10;
  width: 95%;
  max-width: 1600px;
  height: 95%;
  display: flex;
  flex-direction: column;
  padding: 0;
  box-sizing: border-box;
  margin: 1.5% auto;
  border-radius: 20px;
  overflow: hidden;
  background: rgba(15, 30, 60, 0.7);
  backdrop-filter: blur(10px);
  box-shadow: 
    0 0 40px rgba(0, 191, 255, 0.2),
    inset 0 0 20px rgba(0, 191, 255, 0.1);
  border: 1px solid rgba(0, 191, 255, 0.3);
  animation: glow 5s infinite alternate;
}

/* 科技感边角 */
.tech-corner {
  position: absolute;
  width: 40px;
  height: 40px;
  border: 2px solid rgba(0, 191, 255, 0.7);
  z-index: 5;
}

.top-left {
  top: 0;
  left: 0;
  border-right: none;
  border-bottom: none;
  border-top-left-radius: 10px;
}

.top-right {
  top: 0;
  right: 0;
  border-left: none;
  border-bottom: none;
  border-top-right-radius: 10px;
}

.bottom-left {
  bottom: 0;
  left: 0;
  border-right: none;
  border-top: none;
  border-bottom-left-radius: 10px;
}

.bottom-right {
  bottom: 0;
  right: 0;
  border-left: none;
  border-top: none;
  border-bottom-right-radius: 10px;
}

/* 科技感边框 */
.tech-border {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: 
    linear-gradient(90deg, rgba(0, 191, 255, 0.4) 25%, transparent 75%) top left/120px 1px repeat-x,
    linear-gradient(90deg, rgba(0, 191, 255, 0.4) 25%, transparent 75%) bottom left/120px 1px repeat-x,
    linear-gradient(0deg, rgba(0, 191, 255, 0.4) 25%, transparent 75%) top left/1px 120px repeat-y,
    linear-gradient(0deg, rgba(0, 191, 255, 0.4) 25%, transparent 75%) top right/1px 120px repeat-y;
  animation: border-flow 8s linear infinite;
  opacity: 0.8;
}

.call-section {
  flex: 2;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  min-height: 350px;
  position: relative;
  z-index: 15;
}

.participants-section {
  flex: 1;
  min-height: 200px;
  margin: 0 20px 20px;
  position: relative;
  z-index: 15;
}

/* 动画定义 */
@keyframes pulse {
  0% {
    opacity: 0.4;
    transform: translate(-50%, -50%) scale(0.95);
  }
  100% {
    opacity: 0.6;
    transform: translate(-50%, -50%) scale(1.05);
  }
}

@keyframes rotate {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes move-lines {
  0% {
    transform: translateX(-20%);
  }
  100% {
    transform: translateX(0%);
  }
}

@keyframes glow {
  0% {
    box-shadow: 
      0 0 30px rgba(0, 191, 255, 0.2),
      inset 0 0 15px rgba(0, 191, 255, 0.1);
  }
  100% {
    box-shadow: 
      0 0 50px rgba(0, 191, 255, 0.3),
      inset 0 0 25px rgba(0, 191, 255, 0.2);
  }
}

@keyframes border-flow {
  0% {
    background-position: 
      top left,
      bottom right,
      top left,
      top right;
  }
  100% {
    background-position: 
      top right,
      bottom left,
      bottom left,
      bottom right;
  }
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes lightEffect {
  0% {
    transform: rotate(45deg) translateY(0);
  }
  100% {
    transform: rotate(45deg) translateY(-50%);
  }
}
</style>

